import { render } from "./UserSubscriptions.vue?vue&type=template&id=390066eb&scoped=true"
import script from "./UserSubscriptions.vue?vue&type=script&lang=js"
export * from "./UserSubscriptions.vue?vue&type=script&lang=js"

import "./UserSubscriptions.vue?vue&type=style&index=0&id=390066eb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390066eb"]])

export default __exports__